import { COMPONENT_NAME } from "../../../constants.js";
const ACCORDION_ITEM_ICON_MAX_HEIGHT = 32;
const ACCORDION_ITEM_ICON_MAX_WIDTH = 32;
const ACCORDION_ITEM_ICON_TEST_ID = `${COMPONENT_NAME}-AccordionItemIcon`;
export {
  ACCORDION_ITEM_ICON_MAX_HEIGHT,
  ACCORDION_ITEM_ICON_MAX_WIDTH,
  ACCORDION_ITEM_ICON_TEST_ID
};
